<template>
  <v-main>
    <AdminSidebar />
    <div class="height-100 lighten-4 px-12 py-6">
      <slot />
    </div>
  </v-main>
</template>

<script>
import AdminSidebar from '../components/admin/Sidebar.vue'

  export default {
  name: 'AdminLayout',
  components: {
    AdminSidebar,
  },
}
</script>